import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { EmpresasService } from '../_services/empresas.service';
import { Norma } from '../_models/norma.model';

import { CuestionarioService } from "../_services/cuestionario.service";

declare var jQuery:any;

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

import * as _ from "lodash";

@Component({
  selector: 'formulariotipocentros',
  templateUrl: 'formulariotipocentros.template.html',
  //providers:  [PreguntasService]
})
export class FormularioTipoCentrosComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() _id_tipocentro: any;
  @Input() _actualizarevidencias: any;

  @Input() puedoeditar: boolean;

  @Output() onChangeTipoCentro = new EventEmitter<boolean>();
  @Output() onCloseTipoCentro = new EventEmitter<number>();
  @Output() onSelectEvidencias = new EventEmitter<boolean>();

  subscription: Subscription;

  id_tipocentro: any;

  etiquetatipocentro: string = "";

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  tipocentro: any = {};

  listainstalaciones: any = [];
  listamodulos : any = [];
  listacuestionarios: any = [];
  listaparametros: any = [];

  contador: number = 1;
  contadorinstalaciones: number = 1;

  instalacionseleccionada:number = 0;
  listainstalacionesseleccionadas: any = [];

  moduloseleccionado: number = 0;
  listamodulosseleccionados: any = [];

  cuestionarioseleccionado: number = 0;

  tipificacionseleccionada: number = 1;

  listaevidencias: any = [];


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private empresasService: EmpresasService,
              private cuestionarioService: CuestionarioService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

  }

  cerrarTipoCentro(destino:number){
    this.cerrarVentana(destino);
  }

  cerrarVentana(destino:number){
    this.onCloseTipoCentro.emit(destino);
  }

  actualizaPadre(){
    this.onChangeTipoCentro.emit(true);
  }

  seleccionarEvidencias(){
    this.onSelectEvidencias.emit(true);
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_id_tipocentro']){
      this.id_tipocentro = changes['_id_tipocentro'].currentValue;
    }

    this.tipocentro.descripcion = "";
    this.tipocentro.abr = "";
    this.tipocentro.id_modulo = 0;
    this.tipocentro.id_cuestionario = 0;
    this.tipocentro.id_tipocentro = 0;

    if (this.id_tipocentro != 0){
      this.getTipoCentro(this.id_tipocentro);
      this.getListaEvidencias(this.id_tipocentro);
      this.tipocentro.id_tipocentro = this.id_tipocentro;
    }

    if (this.id_tipocentro == 0){
      this.etiquetatipocentro = "Nuevo tipo de centro";
    }else{
      this.etiquetatipocentro = "Editar tipo de centro";
    }
    if (!this.puedoeditar){
      this.etiquetatipocentro = "Tipo de centro";
    }

    this.getListaModulos();
    this.getListaInstalaciones();

    if (changes['_actualizarevidencias']){
      if (this.id_tipocentro != 0){
        this.getListaEvidencias(this.id_tipocentro);
      }
    }

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSubmit(a,b){

    this.tipocentro.modulos = [];

    for (let modulo of this.listamodulosseleccionados){
      this.tipocentro.modulos.push(modulo);
    }

    console.log(this.tipocentro);

    this.empresasService.setTipoCentro(this.tipocentro).subscribe(
      data => {
        if (data){
          console.log (data.json());

          let al: any = {
            "texto" : "Tipo de centro guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.actualizaPadre();

        }
      }
    );
  }

  getTipoCentro(id_tipocentro: number){
    this.empresasService.getTipoCentro(id_tipocentro).subscribe(
      data => {

        if (data){
          console.log(data.json().tipocentro);
          this.updateCampos(data.json().tipocentro);
        }

      }
    );
  }

  getListaInstalaciones(){

    this.empresasService.getListaInstalaciones().subscribe(
      data => {
        if (data){
          console.log(data.json());
          this.listainstalaciones = data.json().lista;

          this.listainstalaciones = _.sortBy(this.listainstalaciones,"descripcion");

        }

      }
    );

  }

  getListaEvidencias(id_tipocentro: number){

    this.empresasService.getListaEvidencias(id_tipocentro).subscribe(
      data => {
        if (data){
          this.listaevidencias = data.json().lista;
        }
      }
    );
  }

  getListaModulos(){

    this.normasService.getListaModulos(0).subscribe(
      data => {
        if (data){
          console.log(data.json());
          this.listamodulos = data.json().lista;

          this.listamodulos = _.sortBy(this.listamodulos,"descripcion");

        }

      }
    );
  }

  cambioIdModulo(valor){
    this.getListaCuestionarios(valor);
  }

  getListaCuestionarios(id_modulo:number){

    this.cuestionarioService.getListaCuestionarios(id_modulo).subscribe(
      data => {
        if (data){
          console.log(data.json());
          this.listacuestionarios = data.json().lista;

          this.listacuestionarios = _.sortBy(this.listacuestionarios,"descripcion");

        }
      }
    );

  }

  editar(){
    this.puedoeditar = true;
    this.etiquetatipocentro = "Editar tipo de centro";
    setTimeout(() => this.getListaModulos() , 100);
  }

  updateCampos(tipocentro: any){

    this.tipocentro.id_tipocentro = tipocentro.id_tipocentro;
    this.tipocentro.descripcion = tipocentro.descripcion;
    this.tipocentro.modulos = tipocentro.modulos;

    if (this.tipocentro.modulos.length > 0){
      this.listamodulosseleccionados = this.tipocentro.modulos;
    }else{
      this.listamodulosseleccionados = [];
    }

  }

  eliminarEvidencia(index: number){

    this.empresasService.delEvidenciaTipocentro(this.id_tipocentro, this.listaevidencias[index].id_evidencia).subscribe(
      data => {
        if (data){
          this.listaevidencias = data.json().lista;
        }
      }
    );
  }

  /*updateParametros(){

    if (this.tipocentro.parametros){

      this.contador = 1;
      this.listaparametros = [];

      for (let parametro of this.tipocentro.parametros){

        let param: any = {
          descripcion: parametro.descripcion,
          regexpr: parametro.regexpr,
          id_parametro: parametro.id_parametro,
          id_interno: this.contador,
          id_equipo: this.id_tipocentro
        }

        this.listaparametros.push(param);

        console.log(this.listaparametros);

        this.contador += 1;

      }

    }

  }

  addParametro(){

    let parametro: any = {
      descripcion: "",
      regexpr: "",
      id_parametro: 0,
      id_interno: this.contador
    }

    this.contador += 1;

    this.listaparametros.push(parametro);

  }

  delParametro(param: any){

    let encontrado: number;

    for (let i = 0; i < this.listaparametros.length; i++) {
      if (this.listaparametros[i].id_interno == param.id_interno){
        encontrado = i;
      }
    }

    this.listaparametros.splice(encontrado,1);

  }*/

  anadirModulo(){

    if (this.moduloseleccionado != 0){

      let encontrado: boolean = false;

      console.log("entro");
      for (let a of this.listamodulos){

        if(a.id_modulo == this.moduloseleccionado){

          let encontrado = 0;
          for (let b of this.listacuestionarios){
            if(b.id_cuestionario == this.cuestionarioseleccionado){
              encontrado = 1;
              a.cuestionario = {
                "id_cuestionario": b.id_cuestionario,
                "descripcion": b.descripcion
              }
            }
          }

          if (encontrado ==0){
            a.cuestionario = {
              "id_cuestionario": "0",
              "descripcion": ""
            }
          }

          a.tipificacion = this.tipificacionseleccionada;

          let aux = JSON.parse(JSON.stringify(a));

          this.listamodulosseleccionados.push(aux);
        }
      }


    }

    this.moduloseleccionado = 0;
    this.cuestionarioseleccionado = 0;
    this.tipificacionseleccionada = 1;

    console.log(this.listamodulosseleccionados);

  }

  eliminarModulo(index: any){

    /*let encontrado: number;

    for (let i = 0; i < this.listamodulosseleccionados.length; i++) {
      if (this.listamodulosseleccionados[i].id_modulo == modulo.id_modulo){
        encontrado = i;
      }
    }*/

    this.listamodulosseleccionados.splice(index,1);

    console.log(this.listamodulosseleccionados);

  }


}



// WEBPACK FOOTER //
// ./src/app/tipocentros/formulariotipocentros.component.ts